import { ReportType } from '@app/domain/model/report-type';
import { SpeciesIndustryReportRecord } from './species-industry-report-record';

export class SpeciesIndustryReport {

  readonly amount: number;

   // key - year and month: for species summary
   //       category: for industry
  readonly details: Map<string, SpeciesIndustryReportRecord[]>;

  readonly createdOn: string;

  readonly fisherNumber: number;

  readonly lbsPurchased: number;

  readonly piecesPurchased: number;

  readonly purchaseType: ReportType;

  /**
   * Converts JSON representation of name into {@link SpeciesIndustryReport} instance.
   *
   * @param jsonObject JSON representation of species report
   */
  static fromJSON(jsonObject: any): SpeciesIndustryReport {
    const details = new Map();
    if (jsonObject.details) {
      Object
        .entries(jsonObject.details)
        .forEach(([key, value]) => details.set(key, (value as any[]).map(element => SpeciesIndustryReportRecord.fromJSON(element))));
    }

    const result = Object.create(SpeciesIndustryReport.prototype);
    return Object.assign(result, jsonObject, {
      details: details,
      purchaseType: jsonObject.purchaseType ? ReportType.fromString(jsonObject.purchaseType) : null,
    });
  }

}
